import DropdownIndicator from "components/common/PerPageSelect/components/DropdownIndicator";

export default { DropdownIndicator, IndicatorSeparator: null };
